import { Fragment, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@App/Components/common/IconButton/IconButton";
import { BevEngineIcon, EngineIcon } from "@App/Components/common/Icons";

type EngineTypeStepProps = {
  selectEngine: any;
};

export const EngineTypeStep: FunctionComponent<EngineTypeStepProps> = (
  props: EngineTypeStepProps,
) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="overflow-hidden">
        <div
          className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}
        >
          <IconButton
            title={t("Verbrennungsmotor")}
            onClick={() => props.selectEngine(false)}
            icon={<EngineIcon />}
          />
          <IconButton
            title={t("Elektro-/Hybridmotor")}
            onClick={() => props.selectEngine(true)}
            icon={<BevEngineIcon />}
          />
        </div>
      </div>
    </Fragment>
  );
};
